<template src="./TicketAssigneeSelect.html"></template>

<script>
import { getProjectMembers } from '../../services'

// XAN-193 (adjustments) — the "assigned person" picker used INSIDE a project. Replaces
// Forms/Users/Users.vue within the ticket module: that one is a generic picker listing every
// active user (analysts and client users included), and the valid universe inside a project is not
// that — it is only the users an ADMIN assigned to that project.
//
// It reloads whenever `projectId` changes, so moving a ticket between projects — or adding a new
// member from the Proyectos screen — is reflected without a page reload. The backend applies the
// same filter: this is not the only line of defence.
export default {
  name: 'TicketAssigneeSelect',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    // With no project there is no user universe to show, so the field stays disabled.
    projectId: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Persona asignada'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    collapseSelection: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data: () => ({
    users: []
  }),
  computed: {
    noDataText () {
      return this.projectId
        ? 'Este proyecto no tiene usuarios asignados.'
        : 'Selecciona primero un proyecto.'
    },
    selected () {
      if (Array.isArray(this.value)) return this.value
      return this.value ? [this.value] : []
    },
    // What the "+N" counter spells out on hover, since the collapsed chips are not readable.
    selectedNames () {
      return this.selected
        .map((id) => this.users.find((user) => user.id === id)?.fullname)
        .filter(Boolean)
        .join(', ')
    }
  },
  watch: {
    projectId: {
      immediate: true,
      handler (projectId) {
        this.listMembers(projectId)
      }
    }
  },
  methods: {
    // The custom `selection` slot replaces the built-in chip, and with it `deletable-chips`.
    remove (id) {
      this.$emit('update', this.selected.filter((selectedId) => selectedId !== id))
    },
    async listMembers (projectId) {
      if (!projectId) {
        this.users = []
        return
      }
      try {
        const members = await getProjectMembers(projectId)
        this.users = members.map((user) => ({ ...user, fullname: `${user.name} ${user.lastName || ''}`.trim() }))
      } catch (err) {
        console.error('Error listing project members:', err)
        this.users = []
      }
    }
  }
}
</script>

<style lang="scss" src="./TicketAssigneeSelect.scss" scoped></style>
